/**
 * @internal
 * Table cell query selector
 */
export const TABLE_CELL_SELECTOR = 'td,th';
